import React, { MutableRefObject } from "react";
import ct from "class-types.macro";
import Modal, { Header, Footer, Body } from "~/common/ModalReact";
import Button from "~/common/Buttons";
import Icon from "~/common/Icons/Standard";
import { AddToCartModal } from ".";
interface Props extends AddToCartModal<"warning"> {
  hasAcknowledgedProductWarning?: MutableRefObject<boolean>;
  setHasAcknowledgedProductWarning?: React.Dispatch<React.SetStateAction<boolean>>;
  warningContent: string;
}
const ProductWarningModal = ({
  isOpen,
  hasAcknowledgedProductWarning,
  setHasAcknowledgedProductWarning,
  warningContent,
  closeModal,
  submitModal
}: Props) => {
  const handleAddToCart = async (event: React.SyntheticEvent) => {
    event.preventDefault();
    if (hasAcknowledgedProductWarning) {
      // eslint-disable-next-line no-param-reassign
      hasAcknowledgedProductWarning.current = true;
    }
    setHasAcknowledgedProductWarning?.(true);
    submitModal();
  };
  return <Modal isOpen={isOpen} onRequestClose={closeModal} className={`${ct("w-11/12")}" modal--md`} data-sentry-element="Modal" data-sentry-component="ProductWarningModal" data-sentry-source-file="ProductWarningModal.tsx">
      <Header closeModal={closeModal} data-sentry-element="Header" data-sentry-source-file="ProductWarningModal.tsx">
        <Icon name="attention" className={ct("float-left", "h-6", "text-lg", "mr-1", "w-6")} style={{
        fill: "#F8A12F"
      }} data-sentry-element="Icon" data-sentry-source-file="ProductWarningModal.tsx" />
        <h3 className={ct("flex", "text-base", "m-0", "ml-3", "md:text-xl")}>
          Please Note!
        </h3>
      </Header>
      <Body className={ct("mt-5")} data-sentry-element="Body" data-sentry-source-file="ProductWarningModal.tsx">
        <div className={`${ct("text-sm", "leading-5")}`}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: warningContent
      }} />
      </Body>
      <Footer data-sentry-element="Footer" data-sentry-source-file="ProductWarningModal.tsx">
        <Button className={ct("ml-3")} color="blue" type="submit" onClick={handleAddToCart} data-sentry-element="Button" data-sentry-source-file="ProductWarningModal.tsx">
          I Understand
        </Button>
      </Footer>
    </Modal>;
};
export default ProductWarningModal;